<template>
  <div class="loader">
    <span class="loader__spinner"></span>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;

  backdrop-filter: blur(4px);

  z-index: 99;
}

.loader__spinner {
  display: block;

  width: 32px;
  height: 32px;

  border: 3px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;

  animation: loader-spin 0.7s linear infinite;
}

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
